import React from 'react';

import handShakeIcon from 'images/partners/hand-shake.svg';

const PartnerHeader = () => {
  return (
    <div className="tw-flex tw-flex-col sm:tw-flex-row tw-items-center sm:tw-items-start tw-my-40 sm:tw-my-48 tw-px-16 sm:tw-px-28">
      <img src={handShakeIcon} className="sm:tw-mr-32 tw-mb-8 sm:tw-mb-0 tw-py-6" />
      <div>
        <h1 className="tw-text-headline-xl tw-text-center sm:tw-text-left tw-text-primary-black tw-font-serif tw-m-0">
          Partners
        </h1>
        <p className="tw-mt-16 sm:tw-mt-24 tw-mb-0 tw-text-primary-black tw-font-serif tw-body-lg sm:tw-text-[1.5rem] tw-max-w-full md:tw-max-w-[78%]">
          We welcome working with companies to help them access our journalism and reach our
          subscribers with high-quality messages.
        </p>
      </div>
    </div>
  );
};

export default PartnerHeader;
